(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CompendiumReportGroupController', CompendiumReportGroupController);

    CompendiumReportGroupController.$inject = ['CompendiumReportGroup', 'GUIUtils', '$q', 'Laboratory', '$uibModal',
        'CoreService', 'GenericEntityDatatableService', 'PopupService',
        'ConfirmationService'];

    function CompendiumReportGroupController(CompendiumReportGroup, GUIUtils, $q, Laboratory, $uibModal,
                                             CoreService, GenericEntityDatatableService, PopupService,
                                             ConfirmationService) {
        var vm = this;

        vm.laboratory = null;

        vm.descriptor = {
            title: 'Compendium Report Groups',
            newAction: false,
            entityClassHumanized: 'Compendium Report Groups',
            entityStateName: 'compendium-report-group',
            service: CompendiumReportGroup,
            serviceMethod: 'findAllByLaboratory',
            pagination: 'remote',
            params: {},
            options: [{key: 'aaSorting', value: [[1, 'asc']]}],
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    title: 'Laboratory',
                    render: function () {
                        return vm.laboratory.name;
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction('compendium-report-group'), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('compendium-report-group'), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Compendium Report Group',
                            action: function () {
                                return add();
                            },
                            disabled: function () {
                                return vm.laboratory === null;
                            }
                        })
                    ]
                }
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getCheckAction(), {
                            name: 'Select Laboratory',
                            action: function (filter) {
                                return $q(function (resolve) {
                                    PopupService.showSelectLaboratoryPopup(filter).result.then(function (result) {
                                        filter.laboratoryId = result;

                                        vm.laboratory = result;
                                        vm.descriptor.title = 'Compendium Report Group - ' + vm.laboratory.name

                                        resolve();
                                    });
                                })
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'laboratoryId',
                    visible: false,
                    read: function (filter) {
                        return filter.laboratoryId ? filter.laboratoryId.id : null;
                    }
                }
            ],
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-report-group/update/compendium-report-group-dialog.html',
                    controller: 'CompendiumReportGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null,
                                laboratory: vm.laboratory
                            };
                        },
                    }
                }).result.then(function () {
                    resolve();
                });
            })
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-report-group/update/compendium-report-group-dialog.html',
                    controller: 'CompendiumReportGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CompendiumReportGroup', function (CompendiumReportGroup) {
                            return CompendiumReportGroup.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Compendium Report Group').result.then(function () {
                    CompendiumReportGroup.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
